import { get } from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { DonationSchemeRecord } from "@project/types/donation-scheme";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "../admin/list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/donation-schemes`;

class PublicDonationSchemeService {
  listActiveSchemes = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<DonationSchemeRecord>> =>
    fetchListPage<DonationSchemeRecord>(`${BASE}/`, {
      page_size: 100,
      ...query,
      status: "active",
    });

  getScheme = async (
    id: number | string
  ): Promise<DonationSchemeRecord | undefined> => {
    const data = await get<
      ApiItemResponse<DonationSchemeRecord> | DonationSchemeRecord
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };
}

export const publicDonationSchemeService = new PublicDonationSchemeService();
